import { createAction } from 'deox';
import { AppState, SET_APP_STATE } from './types';

export const setAppStateAction = createAction(SET_APP_STATE, resolve => (payload: AppState) => {
  return resolve(payload);
});
